/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import queryString from "query-string";
import { Header, Footer } from "../../../components/index";
import FailData from "../failData";
import SuccessData from "../successData";
import { WebApi } from "../../../api/web";

const BankData = () => {
  const [consultingData, setConsultingData] = useState(null);
  const [error, setError] = useState(false);
  let url = window.location.search;
  let query = queryString.parse(url);

  useEffect(() => {
    SingleConsulting();
  }, []);

  const SingleConsulting = async () => {
    localStorage.setItem("consultingId", query.id);
    await WebApi.singleConsulting(query.id)
      .then((res) => {
        setConsultingData(res.data.data.consulting);
        if (!res.data.data.consulting.ref) {
          setError(true);
        }
      })
      .catch((err) => {
        setError(true);
      });
  };
  return (
    <>
      <Header title='فاکتور پرداخت' />
      {error ? (
        <FailData data={consultingData} type={3} />
      ) : (
        <SuccessData data={consultingData} type={3} />
      )}
      <Footer />
    </>
  );
};
export default BankData;
